import * as Comlink from 'comlink';

import { getVisualizationProps } from '../workflows';

const workerApi = {
    getVisualizationProps: getVisualizationProps,
};

export type VisualizationWorkerApi = typeof workerApi;

Comlink.expose(workerApi);
